import React from "react";
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { formatCurrencyShort } from "../formatters";

const TopOrganizationsTable = ({ organizations }) => {
  if (!organizations.length) {
    return (
      <Typography sx={{ fontSize: 13, color: "text.secondary", py: 2 }}>
        No sales orders in the last 30 days.
      </Typography>
    );
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={{ fontSize: 11, textTransform: "uppercase", color: "text.disabled", fontWeight: 600 }}>
            Organization
          </TableCell>
          <TableCell sx={{ fontSize: 11, textTransform: "uppercase", color: "text.disabled", fontWeight: 600 }}>
            Revenue
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {organizations.map((org) => (
          <TableRow key={org.name} sx={{ "&:last-child td": { borderBottom: "none" } }}>
            <TableCell sx={{ fontWeight: 600 }}>{org.name}</TableCell>
            <TableCell>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{ flex: 1, height: 6, borderRadius: "4px", bgcolor: "#faf9f7", overflow: "hidden" }}>
                  <Box
                    sx={{
                      height: "100%",
                      width: `${org.percent}%`,
                      bgcolor: "#4b1f6b",
                      borderRadius: "4px",
                    }}
                  />
                </Box>
                <Typography sx={{ fontSize: 13, whiteSpace: "nowrap" }}>
                  {formatCurrencyShort(org.revenue)}
                </Typography>
              </Box>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default TopOrganizationsTable;
